<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="items"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            :search="search"
            @page-count="pageCount = $event"
            hide-default-footer
            class="borderedTable"
        >
        </v-data-table>
        <v-container>
            <v-row justify="end">
                <v-col cols="3">
                    <v-select
                    :items="itemsPerPageList"
                    v-model="itemsPerPage"
                    label="Items per page"
                    ></v-select>
                </v-col>
                <v-col cols="6">
                    <v-pagination v-model="page" :length="pageCount"></v-pagination>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
  export default {
    name: 'BorderdTable',
    props: {
      items: {
        required: true
      },
      headers: {
        type: Array,
        required: true
      },
      search: {
        type: Array,
        required: false
      }
    },
    data () {
      return {
        page: 1,
        itemsPerPage: 10,
        pageCount: 0,
        itemsPerPageList: [
          5, 10, 20, 50, 100
        ],
      }
    }
  }
</script>